export const getReports = state => state.report.items;
export const isLoadingValue = state => state.report.isLoading;
